/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_ProductInputs */

const en_mk_foot_product = /** @type {(inputs: Mk_Foot_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

const id_mk_foot_product = /** @type {(inputs: Mk_Foot_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produk`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Mk_Foot_ProductInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_product = /** @type {((inputs?: Mk_Foot_ProductInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_ProductInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_product(inputs)
	return en_mk_foot_product(inputs)
});